/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell, ColumnInterface } from 'react-table';
import _startCase from 'lodash/startCase';

import { defaultCellWidth } from '../constants';

interface Props<D extends object> {
    cell: Cell<D>;
    column: ColumnInterface<D>;
}

/**
 * Converts text to start case with lodash/startCase.
 */
export function NameCell<D extends object>({
    cell,
    column,
}: Props<D>): JSX.Element {
    const width = (column?.width as number) ?? defaultCellWidth;

    return (
        <div
            className="respond-to-mouse"
            style={{
                width,
            }}
        >
            {_startCase(cell.value)}
        </div>
    );
}
